import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ImageEditorComponent} from './image-editor.component';
import {HistoryPanelComponent} from './panels/history-panel/history-panel.component';
import {ObjectsPanelComponent} from './panels/objects-panel/objects-panel.component';
import {ImageEditorModule} from '../image-editor/image-editor.module';
import {ToolbarControlsModule} from './toolbar-controls/toolbar-controls.module';
import {EditorControlsService} from './toolbar-controls/editor-controls.service';
import {FloatingPanelsService} from './toolbar-controls/floating-panels.service';
import {ActiveDrawerService} from './toolbar-controls/drawers/active-drawer.service';
import { SvgIconModule } from '../editor-tools/core/ui/svg-icon/svg-icon.module';
import {MatButtonModule} from '@angular/material/button';
import {MatRadioModule} from '@angular/material/radio';
import {MatSliderModule} from '@angular/material/slider';
import { CustomScrollbarModule } from '../editor-tools/core/ui/custom-scrollbar/custom-scrollbar.module';
import { BreakpointsService } from '../editor-tools/core/ui/breakpoints.service';
import {OverlayPanel} from '../editor-tools/core/ui/overlay-panel/overlay-panel.service';
import {OverlayContainer} from '@angular/cdk/overlay';
import {EditorOverlayContainer} from './panels/editor-overlay-container';
import {EditorUiService} from './editor-ui.service';
import { ReorderObjectsDirective } from './panels/objects-panel/reorder-objects.directive';
import { OpenSampleImagePanelComponent } from './panels/open-sample-image-panel/open-sample-image-panel.component';
import {ReactiveFormsModule} from '@angular/forms';
import {BackgroundImageDirective} from './background-image.directive';
import { CanvasStateService } from '../image-editor/canvas/canvas-state.service';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ImageEditorModule,
        ToolbarControlsModule,
        SvgIconModule,
        CustomScrollbarModule,
        MatTabsModule,
        // material
        MatSliderModule,
        MatRadioModule,
        MatButtonModule,
        MatIconModule
    ],
    declarations: [
        ImageEditorComponent,
        HistoryPanelComponent,
        ObjectsPanelComponent,
        ReorderObjectsDirective,
        OpenSampleImagePanelComponent,
        BackgroundImageDirective,
    ],
    entryComponents: [
        OpenSampleImagePanelComponent,
        HistoryPanelComponent,
        ObjectsPanelComponent,
    ],
    exports: [
        ImageEditorComponent,
    ],
    providers: [
        CanvasStateService,
        EditorControlsService,
        FloatingPanelsService,
        ActiveDrawerService,
        BreakpointsService,
        OverlayPanel,
        EditorUiService,
        {provide: OverlayContainer, useClass: EditorOverlayContainer},
    ],
})
export class ImageEditorUIModule {
}
